<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="layout-px-spacing">                
    <div class="row layout-spacing layout-top-spacing" id="cancel-row">
        <div class="col-lg-12">
            <div class="">
            <div class="widget-content searchable-container grid">
                <div class="card-box">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 filtered-list-search align-self-center w-100">
                            <form class="form-inline my-2 my-lg-0">
                                <div class="">
                                    <i class="las la-search toggle-search"></i>
                                    <input (change)="setSearch($event)" [(ngModel)]="currentSearch" name="search" type="text" class="form-control search-form-control  ml-lg-auto" placeholder="{{ 'searchCompanies' | translate }}">
                                </div>
                            </form>
                        </div>
                        <div style="padding: 0 2rem;" class="col-xl-6 col-lg-6 col-md-6 col-sm-5 text-sm-right text-center align-self-center">
                            <div class="d-flex justify-content-sm-end justify-content-center contact-options">
                                <button class="btn btn-primary" (click)="createCompany()">
                                    <i class="las la-plus-circle pr-1"></i>
                                    {{ 'createCompany' | translate }}
                                </button>
                            </div>
                        </div>
                </div>
                <div class="searchable-items grid card-box mt-4">
                    <div style="height: 330px;" class="items" *ngFor="let company of companies">
                        <div class="item-content" style="height: 330px;">
                            <div style="height: 230px;">
                            <img class="logo-img technology-logo" src="assets/img/purview.png" alt="avatar" data-toggle="tooltip" data-placement="top" title="Microsoft Purview">
                            <div class="user-profile" style="margin-top: 0 !important;">
                                <img class="logo-img" *ngIf="!company.logo" src="assets/images/companies/company.png" alt="avatar">
                                <img class="logo-img" *ngIf="company.logo" [src]="company.logo" alt="avatar">
                                <div class="user-meta-info">
                                    <p class="user-name">{{ company.name }}</p>
                                    <!-- <p class="user-work font-16 text-muted mb-0">{{ company.location || 'Localizacion' }}</p> -->
                                </div>
                            </div> 
                            <!-- <p class="font-12 text-center text-muted">{{ company.description }}</p> -->
                            <div class="d-flex company-small-details align-center justify-content-around mt-3">
                                <div class="left text-center">
                                    <p class="font-12 text-muted  mb-0">{{ 'tab.users' | translate }}</p>
                                    <p class="font-18 text-primary strong mt-1">{{ company.userCount }}</p>
                                </div>
                                <div class="right text-center">
                                    <p class="font-12 text-muted  mb-0">{{ 'tab.sync' | translate }}</p>
                                    <p *ngIf="!company.certificatePath" class="font-18 text-primary strong mt-1"> <span class="badge badge-info text-light">{{ 'DEMO' }}</span> </p>
                                    <p *ngIf="company.certificatePath" class="font-18 text-primary strong mt-1"> <span class="badge badge-success text-light">{{ 'tab.active' | translate }}</span> </p>
                                </div>
                            </div>
                            </div>
                            <div class="action-btn mt-3">
                               <a class="btn btn-sm btn-dark" routerLink="edit/{{company.id}}" [state]="company">{{ 'details' | translate }}</a>
                            </div>
                        </div>
                    </div>
                  </div>
                <div class="pagination p13 text-center mt-4 justify-content-center">
                  <ngb-pagination
                    [collectionSize]="collectionSize"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="refreshCompanies()">
                  </ngb-pagination>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
</div>
